import React from 'react';
import ReactDOM from 'react-dom';
import './index.sass';
import './customized/customized.sass';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import { SWRConfig } from 'swr';
// import './library/slick/slick.min.css';

ReactDOM.render(
	<React.StrictMode>
		<SWRConfig
			value={{
				refreshInterval: 0,
				revalidateOnFocus: false,
			}}>
			<BrowserRouter>
				<Routes />
			</BrowserRouter>
		</SWRConfig>
	</React.StrictMode>,
	document.getElementById('root')
);
